import React, { useState } from 'react';
import PropTypes          from 'prop-types';
import './ToggleSwitch.scss';

/** A pill-shaped ON/OFF toggle that emits its new boolean state */
export default function ToggleSwitch({ initial = true, onChange }) {
  const [on, setOn] = useState(initial);

  const handle = () => {
    setOn(!on);
    onChange?.(!on);
  };

  return (
    <button
      className={`toggle-pill ${on ? 'on' : 'off'}`}
      role="switch"
      aria-checked={on}
      onClick={handle}
    >
      {on ? 'ON' : 'OFF'}
    </button>
  );
}

ToggleSwitch.propTypes = {
  initial : PropTypes.bool,
  onChange: PropTypes.func
};
